import React from "react";
import Navbar from "../Navbar";
import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import { ArrowForwardOutlined, BusinessOutlined, LocationOnOutlined, PeopleOutlineOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { config } from "../../../config";
import { APP_VARIANT } from "../../../constants";
import { landingPageContent } from "./LandingPage.content";

export const LandingPage = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleSetup = () => {
        navigate("/auth/signup/setup-company");
    }

    const appVariant = landingPageContent[config.app.variant as "TALKVIT"];

    return (
        <>
            <Navbar pageType="SIGNUP" />
            <Stack
                sx={{
                    minHeight: "100vh",
                    justifyContent: "center",
                    alignItems: "center",
                    px: { xs: 2, md: 3 },
                    pt: { xs: 12, md: 12 },
                    pb: { xs: 4, md: 4 },
                    boxSizing: "border-box",
                    backgroundColor: theme.palette.grey[50],
                }}
            >
                <Typography
                    variant="h1"
                    color="primary.main"
                    fontSize={{ xs: "2.25rem", md: "3rem" }}
                    fontWeight={600}
                    textAlign={"center"}
                >
                    {appVariant.title}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: theme.palette.grey[600],
                        fontSize: { xs: "1rem", md: "1.25rem" },
                        textAlign: "center",
                        mb: { xs: 3, md: 4 },
                        maxWidth: 720,
                    }}
                >
                    {appVariant.subTitle}
                </Typography>
                <Box sx={{ width: "100%", maxWidth: 1100 }}>
                    <Grid container spacing={3} justifyContent="center">
                        {appVariant.cards.map((card, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card
                                    heading={card.title}
                                    subHeading={card.subTitle}
                                    icon={<card.icon />}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
                <Stack mt={{ xs: 3, md: 4 }}>
                    <Button variant="contained" color="primary" size="large"
                        endIcon={<ArrowForwardOutlined />}
                        sx={{ px: 5, py: 1.5, fontSize: "1.1rem", alignSelf: "center", borderRadius: "10px", textTransform: "none" }}
                        onClick={handleSetup}
                    >Get Started</Button>
                </Stack>
            </Stack>
        </>
    );
};


const Card: React.FC<{ heading: string, subHeading: string, icon: React.ReactNode }> = ({
    heading,
    subHeading,
    icon
}) => {
    const theme = useTheme();

    return (
        <Stack sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "20px",
            backgroundColor: '#fff',
            p: { xs: 3, md: 3.5 },
            height: "100%",
        }}>
            <Box sx={{
                "& svg": {
                    fontSize: "3.5rem",
                    color: theme.palette.primary.main
                },
                display: "flex",
                justifyContent: "center",
                mb: 1.5
            }}>
                {icon}
            </Box>
            <Typography
                variant="h3"
                color="primary.main"
                fontSize={"1.4rem"}
                fontWeight={600}
                textAlign={"center"}
                mb={1}
            >
                {heading}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: theme.palette.grey[600],
                    fontSize: "1rem",
                    textAlign: "center",
                }}
            >
                {subHeading}
            </Typography>

        </Stack>
    )
}